export default __webpack_public_path__ + "static/media/powerOfFitness.a9b15a8d.jpg";